import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal } from 'antd';

@inject('oldApplyStore')
@observer
class OldApply extends Component {

  static displayName = 'OldApply'

  render() {
    const { oldApplyStore: { visible, setState } } = this.props;
    return (
      <Modal
        visible={visible}
        onOk={() => setState({ visible: false })}
        onCancel={() => setState({ visible: false })}
      >
        申请
      </Modal>
    )
  }
}

export default OldApply;



// WEBPACK FOOTER //
// ./src/components/oldApply/Apply.js